import * as ActionTypes from '../actionTypes';
import apiActionCreator from '../../../common/service/api/actionCreator';
import {buildErrorMessage} from '../../../common/util/errorUtils';

export const createWtsUser = (data) => (dispatch) => {
  return dispatch(apiActionCreator({
    'endpoint': '/wts/auth/createUser',
    'authenticated': true,
    'types': [
      ActionTypes.CREATING_WTS_USER,
      ActionTypes.CREATED_WTS_USER,
      ActionTypes.CREATED_WTS_USER_FAILED,
    ],
    'microservice': 'part',
    'method': 'POST',
    'contentType': 'application/json',
    'data': data,
  }));
};

export const getWtsUser = (username) => (dispatch) => {
  return dispatch(apiActionCreator({
    'endpoint': `/wts/auth/createUser?username=${username}`,
    'authenticated': true,
    'types': [
      ActionTypes.FETCHING_WTS_USER,
      ActionTypes.FETCHED_WTS_USER,
      [
        ActionTypes.FETCHED_WTS_USER_FAILED,
        (error) => buildErrorMessage(error),
      ],
    ],
    'microservice': 'part',
    'method': 'GET',
  }));
};

export const updateWtsUser = (userId, data) => (dispatch) => {
  return dispatch(apiActionCreator({
    'endpoint': `/wts/auth/createUser?user_id=${userId}`,
    'authenticated': true,
    'types': [
      ActionTypes.UPDATING_WTS_USER,
      ActionTypes.UPDATED_WTS_USER,
      [
        ActionTypes.UPDATED_WTS_USER_FAILED,
        (error) => buildErrorMessage(error),
      ],
    ],
    'microservice': 'part',
    'method': 'PUT',
    'contentType': 'application/json',
    'data': data,
  }));
};

export const clearWtsUser = () => ({'type': ActionTypes.CLEAR_WTS_USER});
